export default "__VITE_ASSET__59fda56d__"